/**
 * @param widthQtyTotal - Sum of (width * qty) for all widths
 * @param length        - Wood length from master
 * @param thickness     - Wood thickness from master
 * @returns CFT value rounded to 2 decimal places
 */
export const calculateCFT = (
  widthQtyTotal: number,
  length: number,
  thickness: number
): number => {
  const cft = (widthQtyTotal * ((length / 12) * thickness)) / 144;
  return parseFloat(cft.toFixed(4));
};

/**
 * @param widths - { [width: number]: number }
 * @returns Sum of (width * qty)
 */
export const getWidthQtyTotal = (
  widths: { [width: number]: number }
): number => {
  return Object.entries(widths).reduce(
    (sum, [w, q]) => sum + Number(w) * (Number(q) || 0),
    0
  );
};